module.exports = __webpack_public_path__ + "static/img/gongsi_pic.a2539b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/gongsi_pic.png
// module id = +4qd
// module chunks = 2